import React, {
  ReactElement, useCallback, useEffect, useRef, useState,
} from 'react';
import { animated } from 'react-spring';
import { ReactComponent as Laptop } from '../../../images/laptop.svg';
import { ReactComponent as Companies } from '../../../images/companies.svg';

import style from './style.module.scss';
import { Typography, TypographyVariants } from '../../ui/typography';

export const BenefitsSection = (): ReactElement => {
  const sectionRef = useRef<HTMLElement>();

  return (
    <section className={style.benefitsSection} ref={sectionRef as any}>
      <div className={style.container}>
        <div className={style.textContainer}>
          <div className={style.description}>
            <Typography variant={TypographyVariants.h3} className={style.title}>Синхронизация</Typography>
            <Typography variant={TypographyVariants.body} component="span" className={style.body}>Совместный просмотр любимых фильмов и видео со своими друзьями и близкими. Синхронизация видео специально для вас.</Typography>
            <Companies className={style.companies} />
          </div>
          <div className={style.description}>
            <Typography variant={TypographyVariants.h3} className={style.title}>Видео. Любое.</Typography>
            <Typography variant={TypographyVariants.body} component="span" className={style.body}>Благодаря технологии вы можете смотреть совместно любое видео. Любой онлайн-кинотеатр, видеоплатформа. Наслаждайтесь просмотром.</Typography>
          </div>
        </div>
        <div className={style.image}>
          <Laptop className={style.laptop} />
        </div>
      </div>
    </section>
  );
};
